<template>
<div>
  <div class="marketplace-buttons-container d-flex justify-content-start flex-wrap flex-lg-nowrap gap-4"
       :class="{'flex-column': stackButtons, 'flex-column-reverse': reverseButtonOrder}"
    v-on:mouseover="$emit('hover')"
  >
    <button
      :data-cy="`${dataCy}-submit`"
      ref="submitButton"
      class="btn"
      :class="{
        'btn-sm': !submitButton.customClasses,
        [submitButton.customClasses]: !!submitButton.customClasses,
        'disabled': submitButtonDisabled || submitting,
        'btn-outline-primary': reverseButtonOrder,
        'btn-primary': !reverseButtonOrder,
      }"
      :disabled="submitButtonDisabled || submitting"
      type="submit"
      @click="submit($event)"
      @keydown.space="submit($event)"
    >
      <ButtonLoadingSpinner v-if="submitting && !customButtonClicked"></ButtonLoadingSpinner>
      <slot name="submitBtnText">
        {{ submitButton.btnText }}
      </slot>
    </button>
    <!-- Link Button with optional icon -->
    <button
      type="button"
    :data-cy="`${dataCy}-link`"
      ref="linkButton"
      class="btn btn-link position-relative"
      :class="{
        'disabled': linkButtonDisabled || (submitting && !linkButtonClicked),
      }"
      :disabled="linkButtonDisabled || (submitting && !linkButtonClicked)"
      :hidden="linkButtonHidden"
      v-if="linkButton"
      @click="onClickLinkButton"
    >
      <ButtonLoadingSpinner v-if="submitting && linkButtonClicked"></ButtonLoadingSpinner>
      <slot name="linkBtnText">
        {{ linkButton.btnText }} <i :class="linkButton.btnIcon"></i>
      </slot>
    </button>
    <button
      type="button"
      :data-cy="`${dataCy}-custom`"
      ref="customButton"
      class="btn position-relative"
      :class="{
        'btn-sm': !customButton.customClasses,
        [customButton.customClasses]: !!customButton.customClasses,
        'disabled': customButtonDisabled || (submitting && !customButtonClicked),
        'btn-outline-primary': !reverseButtonOrder,
        'btn-primary': reverseButtonOrder,
      }"
      :disabled="customButtonDisabled || (submitting && !customButtonClicked)"
      :hidden="customButtonHidden"
      v-if="customButton"
      @click="onClickCustomButton"
    >
      <ButtonLoadingSpinner v-if="submitting && customButtonClicked"></ButtonLoadingSpinner>
      <slot name="customBtnText">
        {{ customButton.btnText }}
      </slot>
    </button>
  </div>
</div>
</template>

<script>
export default {
  name: 'QuestionNav',
  layout: 'marketplace',
  props: {
    dataCy: {
      type: String,
      default: 'button'
    },
    stackButtons: {
      type: Boolean,
      default: false
    },
    reverseButtonOrder: {
      type: Boolean,
      default: false
    },
    'customButton': Object,
    'linkButton': Object,
    'submitButton': Object,
    'submitting': Boolean
  },
  emits: ['submit', 'customAction', 'linkAction', 'hover'],
  computed: {
    submitButtonDisabled() {
      return this.submitButton.disabled
    },
    linkButtonDisabled() {
      return this.linkButton && this.linkButton.disabled
    },
    linkButtonHidden() {
      return this.linkButton && this.linkButton.hidden
    },
    linkButtonClicked() {
      return this.linkButton && this.linkButton.clicked
    },
    customButtonDisabled() {
      return this.customButton && this.customButton.disabled
    },
    customButtonHidden() {
      return this.customButton && this.customButton.hidden
    },
    customButtonClicked() {
      return this.customButton && this.customButton.clicked
    },
  },
  mounted() {
    this.submitButton.attributes && this.addAttributes(this.$refs.submitButton, this.submitButton.attributes)
    this.linkButton && this.addAttributes(this.$refs.linkButton, this.linkButton.attributes)
    this.customButton && this.addAttributes(this.$refs.customButton, this.customButton.attributes)
  },
  methods: {
    addAttributes(element, attributes) {
      for (const attribute in attributes) {
        element.setAttribute(attribute, attributes[attribute])
      }
    },
    submit (e) {
      e.preventDefault()
      if (!this.submitting && !this.disableNext) {
        this.$emit('submit')
      }
    },
    onClickCustomButton() {
      this.$emit('customAction')
    },
    onClickLinkButton() {
      this.$emit('linkAction')
    },
  }
}
</script>

<style scoped lang="scss">
@import "lendio-spinners";
.marketplace-buttons-container {
  @include media-breakpoint-up(lg) {
    max-width: 600px !important;
  }
}
.marketplace-buttons-container-test-c {
  @include media-breakpoint-up(lg) {
    max-width: 225px !important;
  }
}
button {
  @include media-breakpoint-down(lg) {
    width: 100%;
  }
}
.btn-link {
  font-weight: 600;
}
</style>
